import c from "./CardAnnotation.module.scss";
import ActionBtnItem from "../utils/ActionBtnItem";
import useDateFormatter from "../../hooks/date-formatter.hook";
import { ANNOTATION_TYPE_HELPER } from "../../lib/utils";
import Chip from "../chip/Chip";

function CardAnnotation({
	active,
	onClick,
	annotation,
	onEdit = () => {},
	onDelete = () => {},
	onDownload = () => {},
	role,
}) {
	const { formatDate } = useDateFormatter();

	return (
		// biome-ignore lint/a11y/useSemanticElements: the selectable card contains independent action buttons.
		<div
			className={`${c.main_card_annotation} ${active ? c.active : ""}`}
			onClick={onClick}
			onKeyDown={(event) => {
				if (event.target === event.currentTarget && (event.key === "Enter" || event.key === " ")) {
					event.preventDefault();
					onClick();
				}
			}}
			role="button"
			tabIndex={0}
		>
			<div className={c.main_intro}>
				<div className={c.wrap_intro}>
					<div className={c.main_icon}>
						<span className="icon_16 default note"></span>
					</div>
					<div className={c.title}>{formatDate(annotation.date, "DD MMM YYYY")}</div>
				</div>

				<div className={c.main_actions}>
					{annotation.user_can_update && (
						<ActionBtnItem onClick={onEdit} icon="edit" tooltip="Modifica" />
					)}

					{annotation.user_can_update && (
						<ActionBtnItem onClick={onDelete} icon="delete" tooltip="Elimina" />
					)}

					<ActionBtnItem onClick={onDownload} icon="download" tooltip="Scarica" />
				</div>
			</div>

			<div className="mt-[6px] pl-1">
				<div className="text-12 font-semibold text-dark-70">
					Ultima modifica:{" "}
					{annotation?.last_updated_by
						? `${annotation.last_updated_by.first_name} ${annotation.last_updated_by.last_name}`
						: annotation?.owned_by
							? annotation.owned_by?.display_name
							: "Amministatore"}
				</div>
			</div>

			<div className={c.main_desc}>
				<div className={c.desc}>{annotation.name}</div>
			</div>

			<div className="mt-[6px] flex flex-wrap gap-4">
				<Chip label={ANNOTATION_TYPE_HELPER?.[annotation?.type]?.label || annotation?.type} />
			</div>

			{annotation?.scheduled_event && (
				<div className="mt-[10px]">
					<Chip
						icon="icon_16 default support"
						label={`${annotation?.scheduled_event?.calendly_name} - ${formatDate(annotation?.scheduled_event?.calendly_start_time, "DD/MM/YYYY HH:mm")}`}
					/>
				</div>
			)}
		</div>
	);
}

export default CardAnnotation;
